/* eslint-disable arrow-body-style */
import axios, { AxiosPromise } from 'axios';

export interface IYandexAddressObject {
    GeoObject: {
        Point: {pos: string;};
        boundedBy: {
            Envelope: {
                lowerCorner: string;
                upperCorner: string;
            };
        };
        description: string;
        metaDataProperty: {
            GeocoderMetaData: {
                Address: {
                    Components: {
                        kind: string;
                        name: string;
                    }[];
                    country_code: string;
                    formatted: string;
                };
                AddressDetails: {
                    Country: {
                        AddressLine: string;
                        AdministrativeArea: {
                            AdministrativeAreaName: string;
                            Locality: {
                                Premise: {
                                    PremiseName: string;
                                };
                            };
                        };
                        CountryName: string;
                        CountryNameCode: string;
                    };
                };
                kind: string;
                precision: string;
                text: string;
            };
        };
        name: string;
    };
}

export interface IYandexGeocoderResponse {
    response: {
        GeoObjectCollection: {
            featureMember: IYandexAddressObject[];
            metaDataProperty: {
                GeocoderResponseMetaData: {
                    found: string;
                    request: string;
                    results: string;
                }
            }
        }
    }
}

export const searchAddressesYandex = (search_params: any): AxiosPromise<IYandexGeocoderResponse> => {
    return axios.get('https://geocode-maps.yandex.ru/1.x/', {
        params: search_params
    });
};
